import { Text } from "@chakra-ui/react";
import React from "react";
import uniqid from "uniqid";

const ErrorMessages = ({ formik }) => {
  const { values, touched, errors } = formik;
  const arr = [];
  for (const prop in values) {
    if (touched[prop] && errors[prop]) {
      arr.push(errors[prop]);
    }
  }
  return arr.map((item) => (
    <Text color="red.500" key={uniqid()}>
      {item}
    </Text>
  ));
};

export default ErrorMessages;
